import React, { createContext } from "react";

export const appCtx = createContext({ projectId: "" });
export const { Provider } = appCtx;
